import { Box, Chip, Skeleton, Typography } from '@pocketlaw/tetris';
import { SearchEntityTypeEnum } from 'shared/domains/apollo/generated/types';
import { EntityIcon } from './EntityIcon';
import { SearchResultContainer, SkeletonItemContainer } from './styled';
export function LoadingSkeleton(props) {
    const { count } = props;
    const items = Array(count)
        .fill(null)
        .map((_, index) => index);
    return (<SearchResultContainer>
      {items.map((index) => (<SkeletonItemContainer key={index}>
          <Skeleton borderRadius="circle">
            <EntityIcon type={SearchEntityTypeEnum.Document}/>
          </Skeleton>

          <Skeleton height="1rem" width="20rem">
            <Typography $fontSize="small">...</Typography>
          </Skeleton>

          <Box ml="auto" gap="md" alignItems="center">
            <Skeleton width="5rem" height="1rem">
              <Chip label="..."/>
            </Skeleton>
            <Skeleton width="5rem" height="1rem">
              <Chip label="..."/>
            </Skeleton>
          </Box>
        </SkeletonItemContainer>))}
    </SearchResultContainer>);
}
